var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertSingleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 19,
    viewBox: "0 0 8 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.37848 4.54476L6.39047 4.47852V4.4112C6.39047 2.97551 5.32131 1.68066 3.84855 1.68066C2.3758 1.68066 1.30664 2.97551 1.30664 4.4112V4.47851L1.31862 4.54474L2.55912 11.4005C2.55912 11.4005 2.55912 11.4005 2.55912 11.4005C2.68386 12.09 3.23972 12.5166 3.84846 12.5166C4.45719 12.5166 5.01305 12.09 5.13779 11.4006C5.1378 11.4005 5.1378 11.4005 5.1378 11.4005L6.37848 4.54476Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92759 17.33C5.08692 17.33 5.90206 16.3159 5.90206 15.2267C5.90206 14.1374 5.08692 13.1233 3.92759 13.1233C2.76827 13.1233 1.95312 14.1374 1.95312 15.2267C1.95312 16.3159 2.76827 17.33 3.92759 17.33Z",
    fill: "#F26829",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertSingleIcon);
export default __webpack_public_path__ + "static/media/alert-single-icon.b2fc31d112699064b38b3794994d4e39.svg";
export { ForwardRef as ReactComponent };